import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ShiftEnum, ShiftUtils } from 'src/app/bo/shifts/shift';
import { SiteMapStore } from '../../site-map.store';

@Component({
  selector: 'app-site-map-equipment-panel',
  standalone: true,
  templateUrl: './equipment-panel.component.html',
  styleUrls: ['./equipment-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class SiteMapEquipmentPanelComponent {
  protected readonly store = inject(SiteMapStore);

  protected readonly shiftOptions = [
    ShiftEnum.NightToMorning,
    ShiftEnum.MorningToAfternoon,
    ShiftEnum.AfternoonToEvening,
  ].map(value => ({ value, label: ShiftUtils.formatShiftLabel(value) }));

  /** Valeur au format `yyyy-MM-dd` attendu par `<input type="date">`, en heure locale. */
  protected readonly dateValue = computed(() => {
    const date = this.store.equipmentDate();
    if (!date) return '';
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  });

  protected setDate(value: string): void {
    this.store.equipmentDate.set(value ? new Date(`${value}T00:00:00`) : null);
  }

  protected setShift(value: string): void {
    this.store.equipmentShift.set(value === '' ? null : Number(value));
  }
}
